<footer class="footer">
  <div class="container-fluid">
    <nav class="pull-left">
      <ul>
        <li>
          <a href="https://www.openvantage.co">
            Open Vantage
          </a>
        </li>
      </ul>
    </nav>
    <div class="copyright pull-right">
      &copy; {{ test | date: 'yyyy' }}, made with
      <i aria-hidden="true" class="fa fa-heart heart"></i> by
      <a href="https://www.openvantage.co">Open Vantage</a>
    </div>
  </div>
</footer>
